<div class="eye-view-consignor mb-2">
    <div class="row eye-view-consignor-row">
        <div class="col-4 mogo-bold text-end eye-view-consignor-header">
            @if (isInboundJob) { MT Dehire Point }@else { MT Collect Point }
        </div>
        <div class="col-8 eye-view-consignor-content">
            {{ getEmptyDehirePointName() }}
        </div>
    </div>
    <div class="row eye-view-consignor-row">
        <div class="col-4 mogo-bold text-end eye-view-consignor-header">
            Devan Date
        </div>
        <div class="col-8 eye-view-consignor-content">
            {{ currentLegData?.devanDate | date: 'dd/MM/yyyy'}}
        </div>
    </div>
    <div class="row ">
        <div class="col-4 mogo-bold text-end eye-view-consignor-header">
            Door Direction
        </div>
        <div class="col-8 eye-view-consignor-content">
            {{ currentLegData?.doorDirection }}
        </div>
    </div>
</div>